// extracted by mini-css-extract-plugin
export default {"wrapper":"CardGallery_wrapper__yDlYo"};